import * as yup from 'yup';

export interface FormValues {
  dates: {
    start: Date | null;
    end: Date | null;
  };
  quantities: {
    adults: number;
    children: number;
    infants: number;
  };
  destination: {
    label: string;
    value: string;
  };
}

const schema = yup.object().shape({
  dates: yup.object().shape({
    start: yup.date().default(null).nullable(),
    end: yup.date().default(null).nullable(),
  }),
  quantities: yup
    .object({
      adults: yup.number().required(),
      children: yup.number().required(),
      infants: yup.number().required(),
    })
    .required(),
  destination: yup.object().shape({
    label: yup.string().required(),
    value: yup.string().required(),
  }),
});

export default schema;
